import { getValue, isPending } from 'mobx-async'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { BookingsServicesStore } from '@new/domains/bookings/stores/BookingsServicesStore'

import { FiltersSharedProps } from './Filters.types'

interface BookingServicesFilter extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const BookingServicesFilter: FC<BookingServicesFilter> = observer(props => {
  const servicesOptions = getValue(BookingsServicesStore.serviceOptions) || []
  const isLoading = isPending(BookingsServicesStore.serviceOptions)

  return (
    <CheckboxBasedFilter
      title="Services"
      isSearchEnabled
      searchPlaceholder="Search by service"
      options={servicesOptions}
      isLoadingOptions={isLoading}
      {...props}
    />
  )
})
